let turnstileScriptPromise: Promise<void> | null = null;

function isTurnstileReady(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.turnstile?.render === 'function'
  );
}

function loadTurnstileScript(): Promise<void> {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (isTurnstileReady()) {
    return Promise.resolve();
  }

  if (turnstileScriptPromise) {
    return turnstileScriptPromise;
  }

  turnstileScriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(
      'script[data-ff-turnstile]'
    );

    if (existing) {
      const isLoaded =
        isTurnstileReady() ||
        existing.getAttribute('data-ff-turnstile-loaded') === 'true';

      if (isLoaded) {
        resolve();

        return;
      }

      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener(
        'error',
        () => reject(new Error('Turnstile failed to load')),
        { once: true }
      );

      return;
    }

    const script = document.createElement('script');

    script.src =
      'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.setAttribute('data-ff-turnstile', 'true');

    script.onload = () => {
      script.setAttribute('data-ff-turnstile-loaded', 'true');
      resolve();
    };

    script.onerror = () => reject(new Error('Turnstile failed to load'));
    document.head.appendChild(script);
  });

  return turnstileScriptPromise;
}

export default loadTurnstileScript;
